import { COOKIE_KEY } from '@config/constanta';
import { getCookie } from '@ajaibid/utils';

export function getAccessToken() {
  return getCookie(COOKIE_KEY.access_token);
}

export function getOtpToken() {
  return getCookie(COOKIE_KEY.otp_token);
}

export function getPinToken() {
  return getCookie(COOKIE_KEY.pin_token);
}

export function getRefreshToken() {
  return getCookie(COOKIE_KEY.refresh_token);
}

export function getRefreshPinToken() {
  return getCookie(COOKIE_KEY.pin_refresh);
}
